/*
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VJsoneditor from 'v-jsoneditor/src/index'
import VueCodemirror from 'vue-codemirror';
import moment from 'moment-timezone'
import axios from 'axios';
import VueLocalforage from 'v-localforage'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Vue2Editor from "vue2-editor";
import VueMobileDetection from "vue-mobile-detection";
import { VueCsvImportPlugin } from 'vue-csv-import';
import Inputmask from "inputmask";
import '@/components/formio-providers/ozg-storage.js'

import { Components } from "formiojs";
import ImageSelectorV1 from "./components/formio/ImageSelectorV1"
import GoogleCaptcha from "./components/formio/GoogleCaptcha";
import ConnectToStripe from "./components/formio/ConnectToStripe";
import ImageSelector from "./components/formio/ImageSelector"
import ConnectToIconManager from "./components/formio/ConnectToIconManager";

Components.addComponent("imageselectorV1", ImageSelectorV1);
Components.addComponent("googlecaptcha", GoogleCaptcha);
Components.addComponent("connecttostripe", ConnectToStripe);
Components.addComponent("imageselector", ImageSelector);
Components.addComponent("connecttoiconmanager", ConnectToIconManager);

import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/htmlmixed/htmlmixed';
Vue.use(Inputmask)


import VueSession from 'vue-session'


Vue.use(VueSession)
Vue.use(VueCsvImportPlugin);

Vue.use(Vue2Editor);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VJsoneditor)
Vue.use(VueLocalforage)
Vue.use(VueMobileDetection);

axios.defaults.headers.common['Content-Type'] = "application/json";
axios.defaults.validateStatus = function() {
    return true;
};
Vue.use(VueCodemirror);
const ComponentContext = require.context('./components/', true, /\.vue$/i, 'lazy');

ComponentContext.keys().forEach((componentFilePath) => {

    const componentName = componentFilePath.split('/').pop().split('.')[0];
    Vue.component(componentName, () => ComponentContext(componentFilePath));

});


Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(value).format("DD.MM.YYYY");
    }
});

Vue.filter('formatDateShort', function(value) {
    if (value) {
        return moment(value).format("DD.MM");
    }
});
Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(value).format("DD.MM.YYYY HH:mm");
    }
});
Vue.filter('formatTime', function(value) {
    if (value) {
        return moment(value).format("HH:mm");
    }
});


var filterTruncate = function(text = "", length = 200, clamp) {
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filterTruncate);
import Element from "./classes/Element";
window.Element = Element;
import Section from "./classes/Section";
window.Section = Section

import JQuery from 'jquery'
window.$ = JQuery

window.jQuery = JQuery


Vue.directive('input-mask', {


    bind: function(el) {
        $(el).inputmask({
            mask: $(this).attr("mask")
        });

    },
});
import DataTables from 'datatables.net-dt'
//import "datatables.net-select-dt"
//import "datatables.net-searchpanes-bs5"
//import "datatables.net-searchpanes-dt"
//import "datatables.net-colreorder-dt"

import "datatables.net-scroller-dt"
import "datatables.net-staterestore-dt"


Vue.config.productionTip = false
import config from "./config/config.js";
window._config = config


const compiler = require("vue-template-compiler");

window.compiler = compiler
window.GLOBALAXIOS = axios;
window.GLOBALCONFIG = config
window.VueGlobal = Vue;


window.GlobalVueInstance = new Vue({
    router,
    render: h => h(App)
}).$mount('#app')

*/
import "./config/TurnOnOffConsoleLogs/console-control.js";

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VJsoneditor from 'v-jsoneditor/src/index'
import VueCodemirror from 'vue-codemirror';
import moment from 'moment-timezone'
import axios from 'axios';
import VueLocalforage from 'v-localforage'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


import "./package-managment/package-gating.js";
import "./package-managment/package-bootstrap.js";

import "./components/formio/ApiDataGridComponent.js"
import "./components/formio/ApiEditGridComponent.js"
import "./components/formio/ApiSelectComponent.js"

import Vue2Editor from "vue2-editor";
import VueMobileDetection from "vue-mobile-detection";
import { VueCsvImportPlugin } from 'vue-csv-import';
import Inputmask from "inputmask";
import '@/components/formio-providers/ozg-storage.js'

import { Components } from "formiojs";
import ImageSelectorV1 from "./components/formio/ImageSelectorV1"
import GoogleCaptcha from "./components/formio/GoogleCaptcha";
import ConnectToStripe from "./components/formio/ConnectToStripe";
/*import ImageSelector from "./components/formio/ImageSelector"*/
import ConnectToIconManager from "./components/formio/ConnectToIconManager";
import ApiSelectComponent from './components/formio/ApiSelectComponent.js'
import ApiDataGridComponent from './components/formio/ApiDataGridComponent.js'
import ApiEditGridComponent from './components/formio/ApiEditGridComponent.js'
import ApiInfoPanelComponent from './components/formio/ApiInfoPanelComponent.js'
import BundIdAuthenticationComponent from './components/formio/BundIdAuthenticationComponent.js'


Components.addComponent("imageselectorV1", ImageSelectorV1);
Components.addComponent("googlecaptcha", GoogleCaptcha);
Components.addComponent("connecttostripe", ConnectToStripe);
/*Components.addComponent("imageselector", ImageSelector);*/
Components.addComponent("connecttoiconmanager", ConnectToIconManager);


import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/htmlmixed/htmlmixed';
Vue.use(Inputmask)

import VueSession from 'vue-session'

Vue.use(VueSession)
Vue.use(VueCsvImportPlugin);

Vue.use(Vue2Editor);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VJsoneditor)
Vue.use(VueLocalforage)
Vue.use(VueMobileDetection);

axios.defaults.headers.common['Content-Type'] = "application/json";
axios.defaults.validateStatus = function() {
    return true;
};

/* =========================================================
   JWT aus URL ?t=... einmalig in localStorage übernehmen
   und danach aus der URL entfernen
========================================================= */
try {
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get('t');

    if (tokenFromUrl) {
        localStorage.setItem('ozgJwt', tokenFromUrl);

        /*
        params.delete('t');
        const newQuery = params.toString();
        const newUrl =
            window.location.pathname +
            (newQuery ? '?' + newQuery : '') +
            window.location.hash;

        window.history.replaceState({}, document.title, newUrl);
        */
    }
} catch (e) {
    console.warn('[OZG] Token aus URL konnte nicht übernommen werden', e);
}

/* =========================================================
   JWT bei jedem Axios-Request automatisch mitsenden
========================================================= */
axios.interceptors.request.use(
    function(config) {
        const token = localStorage.getItem('ozgJwt');

        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = 'Bearer ' + token;
        }

        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

Vue.use(VueCodemirror);
const ComponentContext = require.context('./components/', true, /\.vue$/i, 'lazy');

ComponentContext.keys().forEach((componentFilePath) => {
    const componentName = componentFilePath.split('/').pop().split('.')[0];
    Vue.component(componentName, () => ComponentContext(componentFilePath));
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(value).format("DD.MM.YYYY");
    }
});

Vue.filter('formatDateShort', function(value) {
    if (value) {
        return moment(value).format("DD.MM");
    }
});

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(value).format("DD.MM.YYYY HH:mm");
    }
});

Vue.filter('formatTime', function(value) {
    if (value) {
        return moment(value).format("HH:mm");
    }
});

var filterTruncate = function(text = "", length = 200, clamp) {
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filterTruncate);

import Element from "./classes/Element";
window.Element = Element;

import Section from "./classes/Section";
window.Section = Section

import JQuery from 'jquery'
window.$ = JQuery
window.jQuery = JQuery

Vue.directive('input-mask', {
    bind: function(el) {
        $(el).inputmask({
            mask: $(this).attr("mask")
        });
    },
});

import DataTables from 'datatables.net-dt'
//import "datatables.net-select-dt"
//import "datatables.net-searchpanes-bs5"
//import "datatables.net-searchpanes-dt"
//import "datatables.net-colreorder-dt"
import "datatables.net-scroller-dt"
import "datatables.net-staterestore-dt"

Vue.config.productionTip = false

import config from "./config/config.js";
window._config = config

const compiler = require("vue-template-compiler");
window.compiler = compiler
window.GLOBALAXIOS = axios;
window.GLOBALCONFIG = config
window.VueGlobal = Vue;

window.GlobalVueInstance = new Vue({
    router,
    render: h => h(App)
}).$mount('#app')